





























import Vue from "vue"
import Component from "vue-class-component"

import Page from "custom/Page.vue"
import ContentHeader from "custom/ContentHeader.vue"

@Component({
components: {
	Page,
	ContentHeader
}
})
export default class Disclaimer extends Vue {}
